// extracted by mini-css-extract-plugin
export var currencyInput = "_nr-1";
export var currencySymbol = "_nr-0";